import { useQuery } from "@tanstack/react-query";
import { catalogService } from "../services/catalogService";

const STALE = 1000 * 60 * 60;

/**
 * Carga los tres catálogos usados en perfil y creación de encuentros.
 */
export function useProfileCatalogs() {
  const physical = useQuery({
    queryKey: ["catalog", "physical-characteristics"],
    queryFn: () => catalogService.getPhysicalCharacteristics(),
    staleTime: STALE,
  });
  const partnerPreferences = useQuery({
    queryKey: ["catalog", "partner-preferences"],
    queryFn: () => catalogService.getPartnerPreferences(),
    staleTime: STALE,
  });
  const kinks = useQuery({
    queryKey: ["catalog", "kinks"],
    queryFn: () => catalogService.getKinks(),
    staleTime: STALE,
  });

  const isLoading = physical.isPending || partnerPreferences.isPending || kinks.isPending;

  return {
    physical: physical.data,
    partnerPreferences: partnerPreferences.data,
    kinks: kinks.data,
    isLoading,
    isError: physical.isError || partnerPreferences.isError || kinks.isError,
    refetch: () => Promise.all([physical.refetch(), partnerPreferences.refetch(), kinks.refetch()]),
  };
}
